<script lang="ts">
	import classNames from 'classnames';
	import { twMerge } from 'tailwind-merge';
	import { CardTag } from '../CardTag';
	import { TagCross } from '../CardTag/TagCross';
	import { TagText } from '../CardTag/TagText';
	import { NewsMixpanelEvents } from '#lib/features/news/constants/mixpanel-events.js';
	import { getTagLink } from '#lib/features/news/utils/getTagLink/getTagLink.js';
	import { getSearchVariables } from '#lib/websites/news/pages/NewsHomePage/utils/getSearchVariables/getSearchVariables.js';
	import { isGeotagActive } from '#lib/websites/news/pages/NewsHomePage/utils/isGeoTagActive/isGeoTagActive.js';
	import { page } from '$app/state';
	import { track } from '$global/utils/track';

	let {
		dataCy,
		name,
		showNewVersion,
		showCross = false,
		onClickCross = undefined,
		onClick = undefined,
		href,
		forceShowGlobalNav = undefined,
		...rest
	}: Props = $props();

	interface Props {
		href?: string | null;
		class?: string;
		dataCy: string;
		name: string;
		showNewVersion: boolean;
		showCross?: boolean;
		onClickCross?: (() => void) | undefined;
		onClick?: (() => void) | undefined;
		forceShowGlobalNav?: boolean | undefined;
	}

	let searchParams = $derived(page.url.searchParams);
	let variables = $derived(getSearchVariables(searchParams));
	// The URL param is the fallback authority: on error pages (and any route
	// whose load doesn't provide showGlobalNav) page.data is empty, and
	// app-mode (global_nav=0) visitors must stay on navless links.
	let showGlobalNav = $derived(
		forceShowGlobalNav ??
			page.data.showGlobalNav ??
			page.url.searchParams.get('global_nav') !== '0'
	);

	let active = $derived(
		isGeotagActive({
			searchGeotag: name,
			variables,
		})
	);
</script>

{#if name}
	<CardTag
		{showNewVersion}
		onclick={() => {
			if (onClick) {
				onClick();
			}
			track(NewsMixpanelEvents.Search, { geotag: name });
		}}
		href={href !== undefined
			? (href as string)
			: getTagLink(showGlobalNav, 'geotag', name)}
		dataCy={`${dataCy}`}
		class={twMerge(
			classNames(
				'h-[20px] border-amber-600',
				active ? 'bg-amber-600' : 'bg-transparent'
			),
			rest.class
		)}
	>
		<TagText
			color="amber"
			isActive={active}
			label={name}
			class={showCross ? 'pr-6 font-semibold' : 'font-semibold'}
		/>
		{#if showCross}
			<TagCross
				color={active ? 'gray-0' : 'amber-600'}
				onclick={(e: Event) => {
					if (onClickCross) {
						e.preventDefault();
						e.stopPropagation();
						onClickCross();
					}
				}}
			/>
		{/if}
	</CardTag>
{/if}
